export default __webpack_public_path__ + "img/laptop.bd32693f.svg";